document.addEventListener("DOMContentLoaded", () => {
  const skuEl = document.getElementById("sku");
  if (!skuEl) return;

  function updateSKUFromVariantId(variantId) {
    const productJsonEl = document.querySelector('script[type="application/json"][data-section-type="product"]');
    if (!productJsonEl) return;

    const productData = JSON.parse(productJsonEl.textContent).product;
    const variant = productData.variants.find(v => String(v.id) === String(variantId));

    if (variant && variant.sku) {
      skuEl.textContent = `SKU: ${variant.sku}`;
    } else {
      skuEl.textContent = '';
    }
  }

  // Find skjult variant-input
  const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
  if (!variantInput) return;

  // Opdater SKU ved page load
  updateSKUFromVariantId(variantInput.value);

  // Brug MutationObserver til at se, når input.value ændres
  const observer = new MutationObserver(() => {
    updateSKUFromVariantId(variantInput.value);
  });

  observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
});